import React from "react";
import { toast, ToastOptions } from "react-toastify";
import "./ClassicyToast.scss";

interface ClassicyToastContentProps {
  message: string;
  type: "success" | "error" | "warning" | "info";
}

const ClassicyToastContent: React.FC<ClassicyToastContentProps> = ({
  message,
  type,
}) => {
  const getIcon = () => {
    if (type === "success") {
      return "/assets/icons/mac.png";
    } else if (type === "error" || type === "warning") {
      return "/assets/icons/warn.png";
    }
    return "/assets/icons/mac.png";
  };

  return (
    <div className="classicy-toast-content">
      <img src={getIcon()} alt="" className="classicy-toast-icon" />
      <div className="classicy-toast-message">{message}</div>
    </div>
  );
};

// Helper functions to show classic toasts
export const classicyToast = {
  success: (message: string, options?: ToastOptions) => {
    return toast.success(
      () => <ClassicyToastContent message={message} type="success" />,
      {
        autoClose: 5000,
        closeButton: false,
        ...options,
      },
    );
  },
  error: (message: string, options?: ToastOptions) => {
    return toast.error(
      () => <ClassicyToastContent message={message} type="error" />,
      {
        autoClose: 5000,
        closeButton: false,
        ...options,
      },
    );
  },
  warning: (message: string, options?: ToastOptions) => {
    return toast.warning(
      () => <ClassicyToastContent message={message} type="warning" />,
      {
        autoClose: 5000,
        closeButton: false,
        ...options,
      },
    );
  },
  info: (message: string, options?: ToastOptions) => {
    return toast.info(
      () => <ClassicyToastContent message={message} type="info" />,
      {
        autoClose: 5000,
        closeButton: false,
        ...options,
      },
    );
  },
};
